import * as React from 'react';

function SvgSkipForwardBtnFill(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M0 10V2a2 2 0 012-2h12a2 2 0 012 2v8a2 2 0 01-2 2H2a2 2 0 01-2-2zm4.79-6.907A.5.5 0 004 3.5v5a.5.5 0 00.79.407L7.5 6.972V8.5a.5.5 0 00.79.407L11 6.972V8.5a.5.5 0 001 0v-5a.5.5 0 00-1 0v1.528L8.29 3.093a.5.5 0 00-.79.407v1.528L4.79 3.093z' />
		</svg>
	);
}

export default SvgSkipForwardBtnFill;
